import React from 'react';
import { useParams } from 'react-router-dom';

import SpaceTutorsPageShell from './SpaceTutorsPageShell';

const PublicSpacePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const resolution = id ? ({ mode: 'id', spaceId: id } as const) : null;

  return <SpaceTutorsPageShell resolution={resolution} />;
};

export default PublicSpacePage;
